import { Box } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { abbreviatedNumber } from 'src/pages/Yearbooks/presentation/components/Charts/utils';

import { CHART_COLORS } from '../../../constants';

interface ColumnSeries {
  name: string;
  data: number[];
}

interface ColumnChartProps {
  series: ColumnSeries[];
  categories: string[];
  stacked?: boolean;
  monetary?: boolean;
  height?: number;
  formatter?: (value: number) => string;
}

export default function ColumnChart({
  series,
  categories,
  stacked = false,
  monetary = true,
  height = 300,
  formatter,
}: ColumnChartProps) {
  function defaultFormatter(value: number): string {
    if (isNaN(value)) return String(value);
    if (stacked) return `R$ ${abbreviatedNumber(value)}`;
    if (monetary) return `R$ ${abbreviatedNumber(value)}`;
    return value.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
  }

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <ReactApexChart
        type="bar"
        series={series}
        height={height}
        width="100%"
        options={{
          chart: {
            stacked,
            ...(stacked && { stackType: '100%' }),
            toolbar: { show: false },
            zoom: { enabled: false },
            background: 'transparent',
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 500,
            },
          },
          tooltip: {
            theme: 'dark',
            y: { formatter: formatter ?? defaultFormatter },
          },
          colors: CHART_COLORS,
          dataLabels: { enabled: false },
          legend: { show: false },
          grid: { show: false },
          plotOptions: {
            bar: {
              columnWidth: '55%',
              borderRadius: stacked ? 0 : 4,
              borderRadiusApplication: 'end',
              borderRadiusWhenStacked: 'last',
            },
          },
          xaxis: {
            categories,
            type: 'category',
            labels: {
              style: {
                fontWeight: 'bold',
                colors: '#ADB2B1',
              },
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
          },
          yaxis: { labels: { show: false } },
          responsive: [
            {
              breakpoint: 600,
              options: {
                chart: { animations: { enabled: false } },
                plotOptions: { bar: { columnWidth: '70%' } },
              },
            },
          ],
        }}
      />
    </Box>
  );
}
